var _path, _path2, _path3, _path4, _path5, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconDigiWallet40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_16967)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8216 5.47095H13.1303C11.7467 5.47095 10.625 6.5926 10.625 7.97623V33.029C10.625 34.4126 11.7467 35.5343 13.1303 35.5343H24.8216C26.2052 35.5343 27.3269 34.4126 27.3269 33.029V7.97623C27.3269 6.5926 26.2052 5.47095 24.8216 5.47095Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8216 5.47095H13.1303C11.7467 5.47095 10.625 6.5926 10.625 7.97623V33.029C10.625 34.4126 11.7467 35.5343 13.1303 35.5343H24.8216C26.2052 35.5343 27.3269 34.4126 27.3269 33.029V7.97623C27.3269 6.5926 26.2052 5.47095 24.8216 5.47095Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.625 31.2395H27.3269V33.029C27.3269 34.4126 26.2052 35.5343 24.8216 35.5343H13.1303C11.7467 35.5343 10.625 34.4126 10.625 33.029V31.2395Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7974 7.61841H21.8805",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1916_16967",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 14,
    width: 7,
    height: 12
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4712 14.958L29.2067 19.0711V21.3186L34.4712 25.4317L36 24.6693V15.7931L34.4712 14.958Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1916_16967)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.8644 14.3491C34.2562 15.6482 34.9521 17.5967 34.9521 20.1948C34.9521 22.7928 34.2562 24.7414 32.8644 26.0404",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3595 16.0193C31.7514 16.9472 32.4473 18.339 32.4473 20.1948C32.4473 22.0505 31.7514 23.4423 30.3595 24.3702",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4722 18.5247C29.8202 18.8958 29.9941 19.4525 29.9941 20.1948C29.9941 20.9371 29.8202 21.4939 29.4722 21.865",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_16967"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.502686)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconDigiWallet40);
export default __webpack_public_path__ + "static/media/pictogramBeaconDigiWallet40.b9a2d8fe36ee11036229581c836f9372.svg";
export { ForwardRef as ReactComponent };